import { T_MongoDoc, T_MongoId } from "../types/_utils.types";

export enum CASE_STATUS {
  CREATED = "created",
  SPLITTED = "splitted",
  LI_FOUND = "linkedin found",
  EMAIL_FOUND = "email found",
  PHONE_FOUND = "phone found",
  LI_NOT_FOUND = "linkedin not found",
  BOTH_FOUND = "both email and phone found",
  NONE_FOUND = "nothing found",
  MISSING_FIELDS = "missing fields",
  DISCARDED = "discarded",
}

export enum PROCESS_STATUS {
  NONE = "none",
  LLM = "llm",
  PC_LI = "proxycurl linkedin",
  BC = "bettercontact",
  BC_WH = "bettercontact webhook",
  PC_PL = "proxycurl people",
  FAILED = "failed",
  UP_PUSHED = "pushed",
  HP_PUSHED = "pushed hotprospector",
  IL_PUSHED = "pushed instantly",
  ASSIGNMENT = "assignment",
  NOT_REACHABLE = "not reachable",
  NOT_FOUND = "not found",
  WRONG_CONTACT = "wrong contact",
  OTHERS = "others",
}

export enum LEAD_PROCESSING_STEPS {
  SPLIT = "split",
  PROXYCURL = "pc",
  BETTERCONTACTS = "bc",
  PROXYCURL_II = "pcpl",
  DISCARD = "discard",
  UPSTREAM = "push",
}

export type CaseDto = {
  batch: T_MongoId;
  filedOn?: Date;
  publishedOn?: Date;
  createdOn?: Date;
  updatedOn?: Date;
  docketUpdatedOn?: Date;
  caseNumber?: string;
  court?: string;
  judge?: string;
  plaintiff?: string;
  plaintiffLawyers?: string;
  plaintiffLawFirm?: string;
  defendant: string;
  defendantLawyers?: string;
  defendantLawFirm?: string;
  summary: string;
  natureOfSuit?: string;
  natureOfSuitId?: string;
  state: string;
  city: string;
  status: CASE_STATUS;
  step: PROCESS_STATUS;
  logs?: {
    date: Date;
    step: PROCESS_STATUS;
    status?: CASE_STATUS;
    user?: T_MongoId;
    message?: string;
    entry_type?: "system" | "manual";
  }[];
  remarks?: {
    user?: T_MongoId;
    date: Date;
    message: string;
    rating?: number;
  }[];
  // OPEN AI Split Data
  business_name?: string; //
  trade_name?: string[];
  other_business_names?: string[];
  first_name?: string; //
  last_name?: string; //
  nicknames?: string[];
  other_business_owners?: string[];
  type_of_business?: string;
  case_type?: string; //
  issue?: string; //
  amount?: string | number; //
  facebook?: string; //
  // ProxyCurl
  linkedin?: string; //
  proxycurl_data?: any;
  // Better Contacts
  email?: any; //
  phone?: any; //
  bettercontact_response?: any;
  // external links -
  update_pending?: boolean;
  hotprospector?: {
    id?: string;
    last_update?: Date;
    meta?: any;
  };
  instantly?: {
    id?: string;
    last_update?: Date;
    meta?: any;
  };
  hold?: boolean;
  // assigned to concept
  assigned_to?: T_MongoId;
};

export enum BATCH_TYPE {
  CASE_PORTAL = "case_portal",
  DYNAMIC = "dynamic",
}

export type CaseBatchDto = {
  batch_key: string;
  name: string;
  type?: BATCH_TYPE;
  file_path: string;
  parsed_entries: number;
  user?: T_MongoId;
  bettercontact_response?: any | [];
  logs?: {
    date: Date;
    step: PROCESS_STATUS;
    results?: any;
  }[];
};

export type CaseSchemaDto = CaseDto & T_MongoDoc;
export type CreateCaseDto = CaseDto;
export type UpdateCaseDto = Partial<CaseDto>;

export type CaseBatchSchemaDto = CaseBatchDto & T_MongoDoc;
export type UpdateCaseBatchDto = Partial<CaseBatchDto>;

export type Assignment = {
  _id: string;
  name: string;
  email: string;
  total_assigned: number;
  total_completed: number;
  total_updated: number;
  avg_first_update_time: number;
  avg_last_update_time: number;
  email_found: number;
  phone_found: number;
  both_found: number;
};

export enum UPLOAD_TYPE {
  UPLOAD = "Upload",
  DYNAMIC_UPLOAD = "Dynamic Upload",
}
